"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Semaphore = exports.Permit = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Permit = /*#__PURE__*/function () {
  function Permit(onRelease) {
    _classCallCheck(this, Permit);

    this.onRelease = void 0;
    this.isReleased = false;
    this.onRelease = onRelease;
  }

  _createClass(Permit, [{
    key: "release",
    value: function () {
      var _release = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isReleased) {
                  _context.next = 4;
                  break;
                }

                this.isReleased = true;
                _context.next = 4;
                return this.onRelease();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function release() {
        return _release.apply(this, arguments);
      }

      return release;
    }()
  }]);

  return Permit;
}();

exports.Permit = Permit;

var Semaphore = /*#__PURE__*/function () {
  function Semaphore(count) {
    _classCallCheck(this, Semaphore);

    this.availablePermits = void 0;
    this.deferreds = [];
    this.availablePermits = count;
  }

  _createClass(Semaphore, [{
    key: "acquire",
    value: function acquire() {
      if (this.availablePermits > 0) {
        return Promise.resolve(this.createPermit());
      } else {
        var deferred = {};
        deferred.promise = new Promise(function (resolve) {
          deferred.resolve = resolve;
        });
        this.deferreds.push(deferred);
        return deferred.promise;
      }
    }
  }, {
    key: "createPermit",
    value: function createPermit() {
      var _this = this;

      this.availablePermits--;
      return new Permit( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var deferred;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.availablePermits++;

                if (!(_this.deferreds.length > 0)) {
                  _context2.next = 6;
                  break;
                }

                deferred = _this.deferreds.shift();
                deferred.resolve(_this.createPermit());
                _context2.next = 6;
                return deferred.promise;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }]);

  return Semaphore;
}();

exports.Semaphore = Semaphore;